import React from 'react';
import { connect } from 'react-redux';
import { FilePreview } from '@ff-os/shared-react/components/file-preview/FilePreview';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectFileNameById } from '../../_redux';
import { ContextMenuCollapsed } from './ContextMenuCollapsed';
import { ContextMenuExpanded } from './ContextMenuExpanded';

const _UploadPreview = ({ name, url, replace, crop }: Props) => (
    <FilePreview name={name} url={url}>
        {(replace && crop) && (
            <>
                <ContextMenuExpanded replace={replace} crop={crop} />
                <ContextMenuCollapsed replace={replace} crop={crop} />
            </>
        )}
    </FilePreview>
);

type Props = OwnProps & { name: string };

type OwnProps = {
    url: string;
    replace?: () => void;
    crop?: () => void;
    variableIds: string[];
};

const mapStateToProps = (state: GiftPdpState, ownProps: OwnProps) => ({
    name: selectFileNameById(state, ownProps.variableIds[0])!
});

export const UploadPreview = connect(
    mapStateToProps
)(_UploadPreview);